import * as React from 'react';

interface PaymentIconProps {
  brand: string;
  brandName?: string;
  className?: string;
  style?: Object;
}

export default function PaymentIcon(props: PaymentIconProps) {
  return (
    <img
      className={props.className}
      src={`/cms-files/paymentlogos/${props.brand
        .toUpperCase()
        .replace(' ', '')}.svg`}
      alt={props.brandName || props.brand}
      style={props.style}
    />
  );
}
